import { render, staticRenderFns } from "./SideSearchListComponent.vue?vue&type=template&id=04ca7ddb&"
import script from "./SideSearchListComponent.vue?vue&type=script&lang=js&"
export * from "./SideSearchListComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideSearchListComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports